import * as React from "react";
import { useAppSelector } from "../../../store/hooks";
import { Button } from "antd";
import { formSet } from "./utils";
import { cloneDeep, get } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { ArrayString } from "../../../schema/types/org/input";
import { CpArrayStringItem } from "./CpArrayStringItem";
import { store } from "../../../store";
import { CpErrorWarning } from "./CpErrorWarning";
import { CpFormItem } from "./CpFormItem";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { PlusCircleOutlined } from "@ant-design/icons";
import { CpLabelDirtyIndicator } from "./CpLabelDirtyIndicator";
import { Only } from "../../workload/draft/only";

interface DirtyIndicatorConfig {
  isEnabled: boolean;
  only?: {
    name: string;
    checkFn: (value: any) => boolean;
  };
}

interface Props {
  label?: string;
  name: string;
  noMargin?: boolean;
  dirtyIndicator?: DirtyIndicatorConfig;
}
export const CpArrayString: React.FC<Props> = ({ label, name, noMargin, dirtyIndicator }) => {
  const { id } = useCpFormContext();
  const items: ArrayString[] = useAppSelector((state) => get(state, `form.instances.${id}.values.${name}`)) || [];

  const renderDirtyIndicator = () => {
    if (!dirtyIndicator?.isEnabled) return null;

    const indicator = <CpLabelDirtyIndicator name={name} />;

    if (dirtyIndicator.only) {
      return (
        <Only name={dirtyIndicator.only.name} checkFn={dirtyIndicator.only.checkFn}>
          {indicator}
        </Only>
      );
    }

    return indicator;
  };

  function add() {
    const _items = cloneDeep(items);

    const newIndex = _items.length;
    _items.push({ id: uuidv4(), value: "" });
    formSet(id, `values.${name}`, _items);

    formSet(id, `fieldStates.${name}.${newIndex}.value.simulateTouched`, true);

    const form = store.getState().form.instances[id];
    const onBlurCounter = form.meta.onBlurCounter;
    formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
  }

  return (
    <CpFormItem noMargin={noMargin}>
      {label ? (
        <div>
          {label}
          {renderDirtyIndicator()}
        </div>
      ) : null}
      {items.length < 0 ? <div>No Items</div> : null}
      {items.map((item, index) => {
        return <CpArrayStringItem key={item.id} item={item} index={index} name={name} />;
      })}
      <Button block type={`dashed`} onClick={() => add()} iconPosition="start" icon={<PlusCircleOutlined />}>
        Add
      </Button>
      <CpErrorWarning name={`${name}root`} />
    </CpFormItem>
  );
};
